import Config from '@/config'
import Message from '@/utils/message'
import LoginError from '@/utils/login-error'
import Cookies from '@/utils/cookie-provider'
import CookieStorage from '@/utils/cookie-storage'
import { jwtDecode } from 'jwt-decode'

const TokenKey = 'tamara-checkout-token'
const KycTokenKey = `${Config.env}-kyc-shared-token`
const CheckoutIDKey = 'tamara-checkout-id'
const DeviceIDKey = 'tamara-customer-device-id'
const SourceKey = 'tamara-login-type'
const userIDKey = 'tamara-checkout-user-id'

const getKycToken = () => {
  return Cookies.get(KycTokenKey)
}

const setUserId = (userId) => {
  return Cookies.set(
    userIDKey,
    userId,
    CookieStorage.getTamaraDomainCookieAttributes(window)
  )
}

const getUserId = () => {
  return Cookies.get(userIDKey)
}

const removeUserId = () => {
  return Cookies.remove(
    userIDKey,
    CookieStorage.getTamaraDomainCookieAttributes(window)
  )
}

const setKycToken = (token) => {
  Cookies.set(
    KycTokenKey,
    token,
    CookieStorage.getTamaraDomainCookieAttributes(window)
  )
}

const removeKycToken = () => {
  return Cookies.remove(
    KycTokenKey,
    CookieStorage.getTamaraDomainCookieAttributes(window)
  )
}

const getToken = () => {
  return Cookies.get(TokenKey)
}

const setToken = (token) => {
  // share token with the sub-domains
  return Cookies.set(
    TokenKey,
    token,
    CookieStorage.getTamaraDomainCookieAttributes(window)
  )
}
const removeToken = () => {
  return Cookies.remove(
    TokenKey,
    CookieStorage.getTamaraDomainCookieAttributes(window)
  )
}

const getLoginSource = () => {
  return Cookies.get(SourceKey)
}

const setLoginSource = (source) => {
  return Cookies.set(
    SourceKey,
    source,
    CookieStorage.getCookieAttributes(window)
  )
}

const removeLoginSource = () => {
  return Cookies.remove(SourceKey, CookieStorage.getCookieAttributes(window))
}

const getCheckoutId = () => {
  return Cookies.get(CheckoutIDKey)
}

const setCheckoutId = (checkoutId) => {
  return Cookies.set(
    CheckoutIDKey,
    checkoutId,
    CookieStorage.getTamaraDomainCookieAttributes(window)
  )
}

const removeCheckoutId = () => {
  return Cookies.remove(
    CheckoutIDKey,
    CookieStorage.getCookieAttributes(window)
  )
}

const parseAuthError = (err, defaultMessage) => {
  const error = new LoginError(err, defaultMessage)

  return {
    error,
    message: new Message(error.getMessage(), Message.error),
  }
}

const getDeviceId = () => {
  return Cookies.get(DeviceIDKey)
}

const setDeviceId = (deviceId) => {
  return Cookies.set(
    DeviceIDKey,
    deviceId,
    CookieStorage.getTamaraDomainCookieAttributes(window)
  )
}

const removeDeviceId = () => {
  return Cookies.remove(
    DeviceIDKey,
    CookieStorage.getTamaraDomainCookieAttributes(window)
  )
}

const getUserRolesFromToken = (token) => {
  if (!token) {
    return null
  }
  const decoded = jwtDecode(token)

  if (decoded && decoded.roles) {
    return decoded.roles
  }

  return null
}

export {
  getToken,
  setToken,
  getUserId,
  setUserId,
  removeUserId,
  removeToken,
  getKycToken,
  setKycToken,
  removeKycToken,
  getCheckoutId,
  setCheckoutId,
  removeCheckoutId,
  parseAuthError,
  getDeviceId,
  setDeviceId,
  removeDeviceId,
  getLoginSource,
  setLoginSource,
  removeLoginSource,
  getUserRolesFromToken,
}
